import ParentClass from './Parent.js';

class GoogleMaps extends ParentClass {
  constructor() {
    super();
    const moduleClass = '.map-embeds-container';
    if(!super.runThisModule(moduleClass)) return;

    this.mapEmbedToggling();
    $('.google-map').each((i, el) => {
      this.initGoogleMaps(el);
    });
  }

  mapEmbedToggling() {
    $('.map--tabs').on('click', 'button', function(ev){
      const $mapEmbed = $($(this).data('target'));

      $(this).siblings('button.active').removeClass('active');
      $mapEmbed.siblings('.active').removeClass('active');

      $(this).addClass('active');
      $mapEmbed.addClass('active');
    });
  }

  /**
   * Initiate the logo sliders.
   */
   initGoogleMaps( mapEl ) {
    const $gmap = $(mapEl);

    // Get location data.
    const lat = $gmap.data('lat');
    const lng = $gmap.data('lng');

    // Location
    const loc = {
      lat: lat,
      lng: lng
    };

    // Map styles
    const stylesArray = [{featureType:"administrative",elementType:"all",stylers:[{visibility:"off"}]},{featureType:"administrative",elementType:"geometry",stylers:[{visibility:"off"}]},{featureType:"administrative",elementType:"geometry.fill",stylers:[{visibility:"off"}]},{featureType:"administrative",elementType:"geometry.stroke",stylers:[{visibility:"off"}]},{featureType:"administrative.country",elementType:"all",stylers:[{visibility:"off"}]},{featureType:"administrative.locality",elementType:"all",stylers:[{visibility:"off"}]},{featureType:"administrative.locality",elementType:"labels.text",stylers:[{visibility:"off"}]},{featureType:"administrative.locality",elementType:"labels.text.fill",stylers:[{visibility:"off"}]},{featureType:"administrative.locality",elementType:"labels.text.stroke",stylers:[{visibility:"off"}]},{featureType:"administrative.locality",elementType:"labels.icon",stylers:[{visibility:"off"}]},{featureType:"administrative.neighborhood",elementType:"geometry",stylers:[{visibility:"off"}]},{featureType:"administrative.neighborhood",elementType:"geometry.fill",stylers:[{visibility:"off"}]},{featureType:"administrative.neighborhood",elementType:"geometry.stroke",stylers:[{visibility:"off"}]},{featureType:"administrative.neighborhood",elementType:"labels.text",stylers:[{visibility:"off"}]},{featureType:"administrative.neighborhood",elementType:"labels.text.fill",stylers:[{visibility:"off"}]},{featureType:"administrative.neighborhood",elementType:"labels.text.stroke",stylers:[{visibility:"off"}]},{featureType:"administrative.neighborhood",elementType:"labels.icon",stylers:[{visibility:"off"}]},{featureType:"administrative.land_parcel",elementType:"all",stylers:[{visibility:"off"}]},{featureType:"landscape",elementType:"all",stylers:[{visibility:"on"}]},{featureType:"landscape.man_made",elementType:"all",stylers:[{visibility:"on"}]},{featureType:"landscape.man_made",elementType:"geometry.stroke",stylers:[{visibility:"off"}]},{featureType:"landscape.man_made",elementType:"labels",stylers:[{visibility:"off"}]},{featureType:"poi",elementType:"all",stylers:[{visibility:"off"},{saturation:"100"}]},{featureType:"poi",elementType:"geometry",stylers:[{visibility:"on"}]},{featureType:"poi.attraction",elementType:"all",stylers:[{visibility:"off"}]},{featureType:"poi.business",elementType:"all",stylers:[{visibility:"off"}]},{featureType:"poi.government",elementType:"all",stylers:[{visibility:"off"}]},{featureType:"poi.medical",elementType:"all",stylers:[{visibility:"off"}]},{featureType:"poi.park",elementType:"all",stylers:[{visibility:"on"},{saturation:"-83"},{weight:"2.53"}]},{featureType:"poi.place_of_worship",elementType:"all",stylers:[{visibility:"off"}]},{featureType:"poi.school",elementType:"all",stylers:[{visibility:"off"}]},{featureType:"poi.sports_complex",elementType:"all",stylers:[{visibility:"off"}]},{featureType:"road",elementType:"all",stylers:[{visibility:"on"}]},{featureType:"road.highway",elementType:"all",stylers:[{visibility:"off"}]},{featureType:"road.arterial",elementType:"all",stylers:[{visibility:"on"}]},{featureType:"road.local",elementType:"all",stylers:[{visibility:"on"}]},{featureType:"transit",elementType:"all",stylers:[{visibility:"off"}]},{featureType:"water",elementType:"all",stylers:[{visibility:"on"},{saturation:"1"},{lightness:"34"}]}];

    // Map init and settings
    const map = new google.maps.Map($gmap[0], {
      center: loc,
      zoom: 13,
      panControl: !1,
      mapTypeControl: false,
      zoomControl: !0,
      zoomControlOptions: {
        style: google.maps.ZoomControlStyle.SMALL,
        position: google.maps.ControlPosition.LEFT_CENTER
      },
      streetViewControl: !1,
      styles: stylesArray,
      disableDefaultUI: true
    });

    const iconImg = {
      url: '/wp-content/themes/variscale/library/images/components/map-embed/map-pin.svg',
      scaledSize: new google.maps.Size(47, 60)
    }

    // Create marker and add it to map
    const marker = new google.maps.Marker({
      position: loc,
      map: map,
      title: 'Variscale',
      icon: iconImg,
      optimized: false,
    });
  }

}

jQuery(window).on('load', function() {
  new GoogleMaps();
});



// WEBPACK FOOTER //
// ./wp-content/themes/variscale/library/js/classes/GoogleMaps.js